export default __webpack_public_path__ + "static/about-05fbd285b075b1bd4fb78c48483dadb0.png";